// Ding + desktop alert icon buttons (Firefly primary tab row / messenger chrome).
import { useEffect, useState } from "react";
import {
  getDesktopMessageAlertPermission,
  getMessageAlertEnabled,
  requestDesktopMessageAlertPermission,
  setMessageAlertEnabled,
  subscribeMessageAlertSettings,
} from "@/lib/messages/messageAlertAudio";

export type ActivityDockAlertIconsProps = {
  className?: string;
};

export function ActivityDockAlertIcons({ className = "" }: ActivityDockAlertIconsProps) {
  const [dingEnabled, setDingEnabled] = useState(() => getMessageAlertEnabled());
  const [desktopPerm, setDesktopPerm] = useState(() => getDesktopMessageAlertPermission());

  useEffect(() => subscribeMessageAlertSettings(setDingEnabled), []);

  const desktopLabel =
    desktopPerm === "granted"
      ? "Desktop alerts on"
      : desktopPerm === "denied"
        ? "Desktop alerts blocked"
        : "Enable desktop alerts";

  return (
    <div className={["flex items-center gap-1.5", className].filter(Boolean).join(" ")}>
      <button
        type="button"
        onClick={() => setMessageAlertEnabled(!dingEnabled)}
        aria-label={dingEnabled ? "Mute new-message ding" : "Unmute new-message ding"}
        title={dingEnabled ? "Ding on" : "Ding off"}
        className={[
          "relative inline-flex h-9 w-9 items-center justify-center rounded-lg text-sm font-semibold transition-colors",
          dingEnabled
            ? "bg-emerald-600 text-white"
            : "bg-gray-100 text-gray-500 hover:bg-gray-200 dark:bg-zinc-800 dark:text-gray-400 dark:hover:bg-zinc-700",
        ].join(" ")}
      >
        <span aria-hidden>{dingEnabled ? "🔔" : "🔕"}</span>
      </button>
      <button
        type="button"
        disabled={desktopPerm === "denied"}
        onClick={() => {
          if (desktopPerm === "granted") return;
          void (async () => {
            const next = await requestDesktopMessageAlertPermission();
            setDesktopPerm(next);
          })();
        }}
        aria-label={desktopLabel}
        title={desktopLabel}
        className={[
          "relative inline-flex h-9 w-9 items-center justify-center rounded-lg text-sm font-semibold transition-colors",
          desktopPerm === "granted"
            ? "bg-emerald-600 text-white"
            : desktopPerm === "denied"
              ? "cursor-not-allowed bg-gray-100 text-gray-400 dark:bg-zinc-800 dark:text-gray-500"
              : "bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-zinc-800 dark:text-gray-200 dark:hover:bg-zinc-700",
        ].join(" ")}
      >
        <span aria-hidden>🖥</span>
      </button>
    </div>
  );
}
